module.exports = __webpack_public_path__ + "static/lights21-dabb3196fe10adbd6823a6b9b1f18d59.jpg";